import { DcuplInitOptions } from '@dcupl/common';

import { DcuplApi } from './dcupl-api';

/**
 * This is the dcupl core class. It is used to initialize the dcupl library.
 * @param options The options to initialize the dcupl library.
 * @example
 * ```ts
 * const dcupl = new Dcupl();
 * const dcupl = new Dcupl({
 *  config: {
 *   projectId: 'xxx',
 *   apiKey: 'yyy',
 *  },
 * });
 *
 * ```
 */
export class Dcupl<ModelKeys extends string = string> extends DcuplApi<ModelKeys> {
  public version = '1.11.11';
  constructor(options?: DcuplInitOptions) {
    super(options);
  }
}
